import React from "react";

/** Simple, friendly soccer ball SVG used across the site. */
export default function SoccerBall({ size = 24, className = "", strokeColor = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="13" fill="#fff" stroke={strokeColor} strokeWidth="2" />
      <polygon
        points="16,9 20.5,12.2 18.8,17.5 13.2,17.5 11.5,12.2"
        fill={strokeColor}
      />
      <path d="M16 3 L16 9" stroke={strokeColor} strokeWidth="2" />
      <path d="M27.5 12 L20.5 12.2" stroke={strokeColor} strokeWidth="2" />
      <path d="M4.5 12 L11.5 12.2" stroke={strokeColor} strokeWidth="2" />
      <path d="M9 25 L13.2 17.5" stroke={strokeColor} strokeWidth="2" />
      <path d="M23 25 L18.8 17.5" stroke={strokeColor} strokeWidth="2" />
    </svg>
  );
}
